import { badgeLabelFor } from '../release-type.js';
import { h } from './dom.js';

/** The label comes only from the closed release-type vocabulary. */
export function releaseBadgeNode(release) {
  const label = badgeLabelFor(release);
  return label ? h('span', { class: 'release-type-badge', 'aria-hidden': 'true' }, label) : null;
}

/** Library tiles use DOM text nodes for the one accessible link suffix. */
export function releaseBadgeSuffixNode(release) {
  const label = badgeLabelFor(release);
  return label ? h('span', { class: 'lib-visually-hidden visually-hidden' }, `, ${label}`) : null;
}

/** Constant-only partials for string-template tiles. */
export function releaseBadgeHtml(release) {
  const label = badgeLabelFor(release);
  return label ? `<span class="release-type-badge" aria-hidden="true">${label}</span>` : '';
}

export function releaseBadgeSuffixHtml(release) {
  const label = badgeLabelFor(release);
  return label ? `<span class="visually-hidden">, ${label}</span>` : '';
}
